import { render, staticRenderFns } from "./selectversion.vue?vue&type=template&id=50a06b08&scoped=true"
import script from "./selectversion.vue?vue&type=script&lang=js"
export * from "./selectversion.vue?vue&type=script&lang=js"
import style0 from "./selectversion.vue?vue&type=style&index=0&id=50a06b08&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a06b08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/rakarapu/compiere-all/pharmanord2011/template/webapps/buybuttoncompact/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50a06b08')) {
      api.createRecord('50a06b08', component.options)
    } else {
      api.reload('50a06b08', component.options)
    }
    module.hot.accept("./selectversion.vue?vue&type=template&id=50a06b08&scoped=true", function () {
      api.rerender('50a06b08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/selectversion.vue"
export default component.exports